// Libs
import React from 'react';

// Styles
import { useStyles } from './KitProductQtyStyles';

const KitProductQty = ({ nums, className }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.qty, className)} data-testid="kit-product-qty">
      {nums}
    </div>
  );
};

export default KitProductQty;
